import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EUIDealsheetService } from '../../../services/essential-ui/eui-dealsheet/EUIDealsheetService';

export type mvoDealsheetlist = {
  campaignEndDate: string;
  campaignId: string;
  campaignStartDate: string;
  closedDealId: string;
  dealerId: string;
  id: number;
  replacementAmVehicleId: string;
};

export type MvoUiState = { mvoDealsheet: number; mvoDealsheetList: mvoDealsheetlist[] };

const initialMvoUiState: MvoUiState = { mvoDealsheet: 1, mvoDealsheetList: [] };

export const getDealsheetMvoList = createAsyncThunk(
  'mvoUi/getDealsheetMvoList',
  async (params: { id: string; dealerId: string }) => {
    const response = await EUIDealsheetService.getEUIDealsheetMvoList(params.id, params.dealerId);
    const list: mvoDealsheetlist[] = [];
    const today = new Date().getTime();
    response.forEach((el) => {
      const campaignExpire = new Date(el.campaignEndDate).getTime();
      if (today <= campaignExpire) {
        list.push(el);
      }
    });

    if (response) return list;
  },
);

const mvoUiSlice = createSlice({
  name: 'mvoUi',
  initialState: initialMvoUiState,
  reducers: {
    setDealsheetMvo(state, action: PayloadAction<number>) {
      state.mvoDealsheet = action.payload;
    },
    setDealsheetMvoList(state, action: PayloadAction<mvoDealsheetlist[]>) {
      state.mvoDealsheetList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDealsheetMvoList.fulfilled, (state, action) => {
      state.mvoDealsheetList = action.payload!;
    });
  },
});

export const { setDealsheetMvo, setDealsheetMvoList } = mvoUiSlice.actions;
export default mvoUiSlice.reducer;
